<template>
  <div>
    <!-- 基础信息 -->
    <section class="pkg-search-box pkg-content pkg-module">
      <p class="pkg-content-title">基础信息</p>
      <div class="pkg-content-form">
        <el-form :model="dataForm"
                  :rules="dataFormRule"
                  ref="dataForm">
          <el-row :gutter="0"
                  style="text-align: center;">
            <!-- 选择用户 -->
            <el-col :span="6">
              <el-form-item :label="$t('trainer.selectUser')"
                            prop="userName">
                <el-input v-model="dataForm.userName"
                          :disabled="true"
                          :placeholder="$t('trainer.selectUser')">
                </el-input>
              </el-form-item>
            </el-col>
            <!--员工号-->
            <el-col :span="6">
              <el-form-item :label="$t('trainer.userCardNo')"
                            prop="userCardNo">
                <el-input v-model="dataForm.userCardNo"
                          :disabled="true"
                          :placeholder="$t('trainer.userCardNo')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 中文姓名 -->
            <el-col :span="6">
              <el-form-item :label="$t('trainer.Name')"
                            prop="userNameCn">
                <el-input v-model="dataForm.userNameCn"
                          :disabled="true"
                          :placeholder="$t('trainer.Name')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 邮件 -->
            <el-col :span="6">
              <el-form-item :label="$t('trainer.mail')"
                            prop="email">
                <el-input v-model="dataForm.email"
                          :disabled="true"
                          :placeholder="$t('trainer.mail')">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0">
            <!-- 手机号码 -->
            <el-col :span="6">
              <el-form-item :label="$t('trainer.phone')"
                            prop="mobile">
                <el-input v-model="dataForm.mobile"
                          :disabled="true"
                          :placeholder="$t('trainer.phone')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 生日 -->
            <el-col :span="6">
              <el-form-item :label="$t('trainer.birthday')"
                            prop="birthday">
                <el-input v-model="dataForm.birthday"
                          :disabled="true"
                          :placeholder="$t('trainer.birthday')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 性别 -->
            <el-col :span="6">
              <el-form-item :label="$t('trainer.sex')"
                            prop="sexCode">
                <el-select v-model="dataForm.sexCode"
                            :disabled="true"
                            :placeholder="$t('trainer.sex')">
                  <el-option v-for="(item,index) in sexType"
                              :key="index"
                              :label="item.name"
                              :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 所属公司 -->
            <el-col :span="6">
              <el-form-item :label="$t('trainer.site')"
                            prop="orgId">
                <el-input v-model="dataForm.abbreviationCn"
                :disabled="true"
                :placeholder="$t('trainer.site')">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0">
            <!-- 所属部门 -->
            <el-col :span="6">
              <el-form-item :label="$t('trainer.departments')"
                            prop="bmwDeptCode">
                <el-input v-model="dataForm.bmwDeptCode"
                          :disabled="true"
                          :placeholder="$t('trainer.departments')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 组织类型 -->
            <el-col :span="6">
              <el-form-item :label="$t('trainer.orgType')"
                            prop="orgType">
                <el-select v-model="dataForm.orgType"
                            :disabled="true"
                            :placeholder="$t('trainer.orgType')">
                  <el-option v-for="(item,index) in userorgType"
                              :key="index"
                              :label="item.name"
                              :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 加入该部门日期 -->
            <el-col :span="6">
              <el-form-item :label="$t('trainer.orgJoinDate')"
                            prop="orgJoinDate">
                <el-input v-model="dataForm.orgJoinDate"
                          :disabled="true"
                          :placeholder="$t('trainer.orgJoinDate')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 培训师编号 -->
            <el-col :span="6">
              <el-form-item :label="$t('trainer.trainerNo')"
                            prop="trainerNo">
                <el-input v-model="dataForm.trainerNo"
                          :disabled='isCity'
                          :placeholder="$t('trainer.trainerNo')">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0">
            <!-- 试讲结束日期 -->
            <el-col :span="6">
              <el-form-item :label="$t('trainer.trialEndDate')"
                            prop="trialEndDate">
                <el-date-picker type="date"
                                :disabled='isCity'
                                value-format="yyyy-MM-dd"
                                v-model="dataForm.trialEndDate"
                                :placeholder="$t('trainer.trialEndDate')">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- 所在城市 -->
            <el-col :span="6">
              <el-form-item prop="city">
                <span slot="label">{{$t('trainer.city')}}</span>
                <class-tree ref="cityclassRef"
                            :disabled='isCity'
                            v-on:getSelectList="getcitySelectList"
                            v-bind:defaultProps="citydefaultProps"
                            v-bind:isOpen=false
                            v-bind:url="queryCityTreeUrl"
                            v-bind:showArray="dataForm.showCityClassList"
                            v-bind:showValue="dataForm.showCityValue"
                            v-on:clearTreeInfo="cityclassInfo"
                            v-bind:listName="'city'"
                            v-bind:isSelect=true></class-tree>
              </el-form-item>
            </el-col>
            <!-- 培训师状态 -->
            <el-col :span="6">
              <el-form-item prop="trainerStatus">
                <span slot="label">{{$t('trainer.status')}}</span>
                <el-select v-model="dataForm.trainerStatus"
                            :disabled="true"
                            :placeholder="$t('trainer.status')">
                  <el-option v-for="(item,index) in statusArr"
                              :key="index"
                              :label="item.name"
                              :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="position">
                <span slot="label">{{$t('trainer.position')}}</span>
                <el-input v-model="dataForm.position"
                          :disabled='isCity'
                          :placeholder="$t('trainer.position')"
                          maxlength="499">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
            <br/>
            <!-- 是否有腾讯会议账号 -->
            <el-row :gutter="0" class="par">
            <div class="pad">
            <!-- <el-tooltip content="培训师腾讯会议企业账号登录名为手机号。该账号仅能参加会议，无法发起会议。" placement="bottom" effect="light" class="item" style="width:30px">
              <em class="el-icon-question" style="color: #1C69D3"></em>
            </el-tooltip> -->
            <el-tooltip placement="bottom" effect="light" class="item">
                                <div slot="content">
                                  培训师腾讯会议企业账号登录名为手机号。<br />该账号仅能参加会议，无法发起会议。
                                </div>
                                <span><em class="el-icon-question" style="color: #1C69D3"></em></span>
                    </el-tooltip>
            </div>
              <el-col :span="6">
                <el-form-item :label="$t('trainer.tencentMeetingAccount')"
                              prop="trialEndDate">
                  <el-input v-model="hasTencentMeetingAccount"
                            :disabled="true"
                            :placeholder="$t('trainer.whether')"
                            maxlength="49">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
        </el-form>
        <!-- 按钮区域 -->
        <div class="btn-position-up btn-position-right">
          <!-- 编辑按钮 -->
          <el-button type="primary"
                      v-show="isShowDataFormUpdate && $hasPermission('AUTHTRAINER0005')&&!disabledEdit"
                      @click="dataFormUpdate()">{{'编辑'}}</el-button>
          <!-- 返回按钮 -->
          <el-button type="info"
                      v-show="isShowDataFormUpdate"
                      @click="backPage()">{{'返回'}}</el-button>
          <!-- 保存按钮 -->
          <el-button type="primary"
                      v-show="isShowDataForm"
                      :loading="dataListLoading"
                      @click="dataFormSubmitHandle()">{{ $t('trainer.save') }}</el-button>
          <!-- 返回按钮 -->
          <el-button type="info"
                      v-show="isShowDataForm"
                      @click="backDataFormPage()">{{ $t('trainer.close') }}</el-button>
        </div>
      </div>
    </section>
    <!-- 年度信息 -->
    <section class="pkg-search-box pkg-content pkg-module">
      <p class="pkg-content-title">年度信息
        <span :class="['show-or-hide', { 'el-icon-arrow-up': isShowHierarchicalInformation, 'el-icon-arrow-down': isShowHierarchicalInformation }]"
              @click="isShowHierarchicalInformation = !isShowHierarchicalInformation">&nbsp;{{ isShowHierarchicalInformation ? '收起' : '展开' }}
        </span>
      </p>
      <div class="pkg-content-form" v-show="isShowHierarchicalInformation">
        <el-tabs v-model="annualTabName"
                  type="border-card">
          <template v-for="(inforItem, index) in trainerAnnualTargetDTOList">
            <el-tab-pane :key="index"
                          :disabled="inforItem.isShow"
                          :label="inforItem.annual"
                          :name="'tab'+index">
              <el-form :disabled='isHierarchicalInformation'
                        :model="inforItem"
                        :rules="targetRule"
                        ref="targetForm">
                <el-row :gutter="0">
                  <!-- 培训师团队分类 -->
                  <el-col :span="6">
                    <el-form-item prop="groupType">
                      <span slot="label">{{$t('trainer.teamClassification')}}</span>
                      <class-tree ref="classRef"
                                  v-show="isGroupTypeU"
                                  v-on:getSelectList="getSelectList"
                                  v-bind:defaultProps="defaultProps"
                                  v-bind:showArray="showGroupTypeList"
                                  v-bind:showValue="showgroupTypeName"
                                  v-bind:url="queryTreeUrl"
                                  v-on:clearTreeInfo="groupType"
                                  v-bind:listName="'groupType'"
                                  :disablePermissionNodes="disablePermissionNodes"
                                  v-bind:isSelect=true></class-tree>
                      <el-input v-model="inforItem.groupTypeName"
                                v-if ="isGroupTypeV"
                                :placeholder="$t('trainer.teamClassification')">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <!-- 培训师角色 -->
                  <el-col :span="6">
                    <el-form-item prop="trainerRole">
                      <span slot="label">{{$t('trainer.role')}}</span>
                      <el-select v-model="inforItem.trainerRole"
                                  :placeholder="$t('trainer.role')">
                        <el-option v-for="(item,index) in trainerRoleArr"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <!-- TA级别 -->
                  <el-col :span="6">
                    <el-form-item prop="taLevel">
                      <span slot="label">{{$t('trainer.taLevel')}}</span>
                      <el-select v-model="inforItem.taLevel"
                                  :placeholder="$t('trainer.taLevel')">
                        <el-option v-for="(item,index) in qualityLevelArr"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <!-- 是否为BEST班主任 -->
                  <el-col :span="6">
                    <el-form-item prop="isBest">
                      <span slot="label">{{$t('trainer.isBest')}}</span>
                      <el-select v-model="inforItem.isBest"
                                  :placeholder="$t('trainer.isBest')">
                        <el-option v-for="(item,index) in confirmStateArr"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="0">
                  <!-- 年度培训目标 -->
                  <el-col :span="6">
                    <el-form-item prop="target">
                      <span slot="label">{{$t('trainer.target')}}</span>
                      <el-input v-model.number.trim="inforItem.target"
                                :placeholder="$t('trainer.target')"
                                maxlength="5">
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <!-- 按钮区域 -->
              <div class="btn-position-up btn-position-right">
                <!-- 新增按钮 -->
                <el-button :loading="addListLoading"
                            type="primary"
                            v-show="isShowHierarchicalUpdate && $hasPermission('AUTHTRAINER0005')&&!disabledEdit"
                            @click="hierarchicalInsert()">{{ $t('add') }}</el-button>
                <!-- 新增保存按钮 -->
                <el-button :loading="dataListLoading"
                            type="primary"
                            v-show="isShowSaveInsert"
                            @click="hierarchicalSubmitHandle(index)">{{$t('trainer.save')}}</el-button>
                <!-- 新增返回按钮 -->
                <el-button type="info"
                            v-show="isShowSaveInsert"
                            @click="hierarchicalCloseInsert()">{{$t('trainer.close')}}</el-button>
                <!-- 编辑按钮 -->
                <el-button type="primary"
                            v-show="isShowHierarchicalUpdate && $hasPermission('AUTHTRAINER0005')&&!disabledEdit"
                            @click="hierarchicalUpdate(index)">{{ $t('update') }}</el-button>
                <!-- 编辑保存按钮 -->
                <el-button type="primary"
                            v-show="isShowHierarchical"
                            :loading="dataListLoading"
                            @click="hierarchicalSubmitHandle(index)">{{ $t('trainer.save') }}</el-button>
                <!-- 编辑返回按钮 -->
                <el-button type="info"
                            v-show="isShowHierarchical"
                            @click="backHierarchicalPage()">{{ $t('trainer.close') }}</el-button>
              </div>
            </el-tab-pane>
          </template>
        </el-tabs>
      </div>
    </section>
    <!-- 合同历史版本信息 -->
    <section class="pkg-search-box pkg-content pkg-module">
      <p class="pkg-content-title">合同信息
        <span :class="['show-or-hide', { 'el-icon-arrow-up': isShowContract, 'el-icon-arrow-down': isShowContract }]"
              @click="isShowContract = !isShowContract">&nbsp;{{ isShowContract ? '收起' : '展开' }}
        </span>
      </p>
      <div class="pkg-content-form" v-show="isShowContract">
        <div class="pkg-content-form-module">
          <p class="pkg-content-stitle">{{ $t('contract.nowActiveContract2') }}</p>
          <el-tabs v-model="historyName"
                  v-loading="saveLoading"
                  v-show="contractHistoryList.length>0"
                  type="border-card" @tab-click="changeTab">
            <template v-for="(inforItem, index) in contractHistoryList">
              <el-tab-pane :key="'contractHistory'+index"
                          :disabled="inforItem.isShow"
                          :label="inforItem.version ? $t('model.version')+(contractHistoryList.length - index) + $t('contract.historyContratInfoActive') : $t('model.version')+(contractHistoryList.length - index)"
                          :name="'contract'+index">
                <span slot="label" class="isActive" v-if="inforItem.version">
                  <el-tooltip class="item"
                        :content="$t('contract.nowActiveContract')"
                        placement="top">
                     <em class="el-icon-document-copy contract-active"></em>
                  </el-tooltip>
                  {{ inforItem.version ? $t('model.version')+(contractHistoryList.length - index) + $t('contract.historyContratInfoActive') : $t('model.version')+(contractHistoryList.length - index) }}
                </span>
                <el-form :disabled="!isShowHistoryInsert"
                          :model="inforItem"
                          :rules="historyRule"
                          class="clearfix"
                          ref="historyForm">
                  <el-form-item prop="contractNo" :label="$t('contract.trainerContractType')" class="contract-history-module">
                    <el-select v-model="inforItem.contractNo"
                              @change="changeContract(inforItem.contractNo, false)"
                              :disabled ="contractList.length===0||(contractList.length===1&&!contractList[0].contractNo)"
                              :placeholder="$t('contract.trainerContractType')">
                      <el-option v-for="(item,index) in contractList"
                                :key="'contranctNo'+index"
                                :label="item.contractNoName"
                                :value="item.contractNo">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="trainerLevelKey" :label="$t('contract.trainerContractLevel')" class="contract-history-module">
                    <el-select v-model="inforItem.trainerLevelKey"
                              :disabled="disabledLevel"
                              :placeholder="$t('contract.trainerContractLevel')">
                      <el-option v-for="(item,index) in contractLevelList"
                                :key="'contractlevel'+index"
                                :label="item.name"
                                :value="item.code ? item.code*1 : ''">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="beginTime" :label="$t('pop.validTime')" class="contract-history-module">
                    <el-date-picker
                      v-model="inforItem.beginTime"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      :pickerOptions="pickerOptions2"
                      :placeholder="$t('user.checkdate')">
                    </el-date-picker>
                  </el-form-item>
                </el-form>
                <div class="btn-position-up btn-position-right">
                  <!-- 保存按钮 -->
                  <el-button type="primary"
                              v-if="isShowHistoryInsert&&$hasPermission('AUTHCONTRACTHISTORY0002')"
                              @click="saveHistory(index)">{{ $t('trainer.save') }}</el-button>
                  <!-- 返回按钮 -->
                  <el-button type="info"
                              v-if="isShowHistoryInsert"
                              @click="backHistoryEdit()">{{ $t('trainer.close') }}</el-button>
                </div>
              </el-tab-pane>
            </template>
          </el-tabs>
          <div class="btn-position-up btn-position-right" v-if="contractList.length>0 && !noContract">
            <el-button :loading="saveLoading"
                        type="primary"
                        :disabled="isShowHistoryInsert"
                        v-if="$hasPermission('AUTHCONTRACTHISTORY0001')&&!disabledEdit"
                        @click="addHistory()">{{ $t('add') }}</el-button>
          </div>
        </div>
        <div class="pkg-content-form-module" v-if="contractHistoryList.length===0&&noContract">
          <div class="pkg-content-form-module-no clearfix">
            <div class="li-module">
              <p class="li-name">{{ $t('contract.trainerContractType') }}</p>
              <p class="li-value">{{ $t('contract.noContract') }}</p>
            </div>
            <div class="li-module">
              <p class="li-name">{{ $t('contract.trainerContractLevel') }}</p>
              <p class="li-value">{{ $t('contract.noLevel') }}</p>
            </div>
            <p class="li-title">{{ $t('contract.noContractInfo') }}</p>
          </div>
        </div>
      </div>
    </section>
    <!-- 标签信息 -->
    <section class="pkg-search-box pkg-content pkg-module">
      <p class="pkg-content-title">标签信息
        <span :class="['show-or-hide', { 'el-icon-arrow-up': isShowLabelInformation, 'el-icon-arrow-down': isShowLabelInformation }]"
              @click="isShowLabelInformation = !isShowLabelInformation">&nbsp;{{ isShowLabelInformation ? '收起' : '展开' }}
        </span>
      </p>
      <div v-show="isShowLabelInformation" class="pkg-content-margin">
        <!--标签区-->
        <el-form label-position="top"
                  label-width="145px"
                  :ref="dataForm"
                  ref="dataForm">
          <el-col :span="24">
              <el-form-item prop="tagName"
                            v-show="isShowLabel"
                            style="width: 100%!important;">
                  <tag :checkedList="checkList"
                        :disabled="false"
                        :moduleId="moduleId"
                        :overLabelShow = "true"
                        :closeShow = "true"
                        :bussinessTypeId = "bussinessTypeId"
                        :brandCode="bussinessTypeChecked"
                        @getBussinessType="getBussinessType"
                        @changeCheckedList="changeCheckedList"
                        ref='tagTree'
                        @fatherMethod="fatherMethod"></tag>
              </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="tagName"
                          v-show="isShowLabelUpdate"
                          style="width: 100%!important;">
                <tag :checkedList="checkList"
                      :disabled="false"
                      :moduleId="moduleId"
                      :overLabelShow = "false"
                      :closeShow = "false"
                      :bussinessTypeId = "bussinessTypeId"
                      :brandCode="bussinessTypeChecked"
                      @getBussinessType="getBussinessType"
                      @changeCheckedList="changeCheckedList"
                      ref='tagTree'
                      @fatherMethod="fatherMethod"></tag>
            </el-form-item>
          </el-col>
        </el-form>
        <div class="btn-position-up btn-position-right" style="margin-right:15px">
          <!-- 保存按钮 -->
          <el-button type="primary"
                      v-show="isShowLabel"
                      :loading="dataListLoading"
                      @click="labelSubmitHandle()">{{ $t('trainer.save') }}</el-button>
          <!-- 返回按钮 -->
          <el-button type="info"
                      v-show="isShowLabel"
                      @click="backlabelPage()">{{ $t('trainer.close') }}</el-button>
          <!-- 编辑按钮 -->
          <el-button type="primary"
                      v-show="isShowLabelUpdate && $hasPermission('AUTHTRAINER0005')&&!disabledEdit"
                      @click="labelUpdate()">{{'编辑'}}</el-button>
        </div>
      </div>
    </section>
    <!-- 行业经验 -->
    <section class="pkg-search-box pkg-content pkg-module">
      <p class="pkg-content-title"><span style="color:red;font-size:9px;">*&nbsp;</span>{{ $t('trainer.industryExperience') }}
        <span :class="['show-or-hide', { 'el-icon-arrow-up': isShowBriefInformation,'el-icon-arrow-down': isShowBriefInformation }]"
              @click="isShowBriefInformation = !isShowBriefInformation">&nbsp;{{ isShowBriefInformation ? '收起' : '展开' }}
        </span>
      </p>
      <div v-show="isShowBriefInformation">
        <!-- 文本区 -->
        <div style="padding-left: 20px;">
          <template v-for="(briefItem, briefIndex) in trainerBriefDTOList">
            <el-row :key="briefIndex"
                    style="margin: 20px 0;"
                    :gutter="0">
              <el-col :span="20">
                <div style="cursor: pointer;"
                      v-show="trainerBriefDTOList.length !== 1 && isShowBrief"
                      @click="briefDelete(briefIndex)"><em class="el-icon-remove"
                      style="color : red;">删除本项</em>
                </div>
                <br>
                <el-input type="textarea"
                          v-show="trainerBriefDTOList[briefIndex].briefType === '1'"
                          :disabled="isBriefContent"
                          placeholder="请介绍培训师的行业经验(限制输入500字)"
                          v-model.trim="trainerBriefDTOList[briefIndex].briefContent"
                          maxlength="500"
                          show-word-limit
                          class="briefContent">
                </el-input>
                <div v-show="trainerBriefDTOList[briefIndex].briefType === '2'">
                  <img alt="" :src="trainerBriefDTOList[briefIndex].imgAddr"
                        style="width: 220px;height: 100px;" alt="trainerImg"/>
                </div>
              </el-col>
              <el-col :span="4">
                <div style="cursor: pointer;"
                      v-show="briefIndex !== 0 && isShowMove"
                      @click="briefMoveUpward(briefIndex)"><em class="el-icon-caret-top">上移</em>
                </div>
                <br>
                <div style="cursor: pointer;"
                      v-show="trainerBriefDTOList.length !== briefIndex+1 && isShowMove"
                      @click="briefMoveDown(briefIndex)"><em class="el-icon-caret-bottom">下移</em>
                </div>
              </el-col>
            </el-row>
          </template>
        </div>
        <div>
          <el-row :gutter="0">
            <el-col :span="3"
                    class="query-button">
              <!--增加文本-->
              <el-button class="M-search"
                          style="padding-left: 10px;width:120px "
                          size="small"
                          v-show="isShowBrief"
                          type="primary"
                          @click="addBrief()">{{ $t('trainer.brief') }}</el-button>&nbsp;
            </el-col>
            <el-col :span="3"
                    class="query-button">
              <el-col :span="24">
                <el-upload v-show="isShowBrief"
                            class="upload-demo"
                            :headers="headers"
                            :action="actionUrl"
                            accept=".jpg,.png"
                            :before-remove="uploadBeforeRemove"
                            multiple
                            :file-list="fileList"
                            :on-success="submitUploadSuccess"
                            :limit="1"
                            :on-exceed="handleExceed"
                            :beforeUpload="beforeAvatarUpload">
                  <el-button class="M-search"
                              style="width: 110px"
                              size="small"
                              type="primary">{{'上传文件'}}</el-button>
                </el-upload>
              </el-col>
            </el-col>
            <el-col :span="18">
              <el-col :span="24">
                <div style="text-align: left;font-size: 12px;color: darkgray; height: 40px; line-height: 35px;" v-show="isShowBrief">{{'建议尺寸比例2.2:1，不超过4M，格式为jpg，png'}}</div>
              </el-col>
            </el-col>
            <el-col :span="24">
              <div class="btn-position-up btn-position-right"
                    style="margin-right: 15px;">
                <!-- 保存按钮 -->
                <el-button type="primary"
                            v-show="isShowBrief"
                            :loading="dataListLoading"
                            @click="briefSubmitHandle()">{{ $t('trainer.save') }}</el-button>
                <!-- 返回按钮 -->
                <el-button type="info"
                            v-show="isShowBrief"
                            @click="backbriefPage()">{{ $t('trainer.close') }}</el-button>
                <!-- 编辑按钮 -->
                <el-button type="primary"
                            v-show="isShowBriefUpdate && $hasPermission('AUTHTRAINER0005')&&!disabledEdit"
                            @click="briefUpdate()">{{'编辑'}}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>
    <!-- 主讲课程 -->
    <section class="pkg-search-box pkg-content pkg-module">
      <p class="pkg-content-title"><span style="color:red;font-size:9px;">*&nbsp;</span>主讲课程
        <span :class="['show-or-hide', { 'el-icon-arrow-up': isShowCurriculumInformation,'el-icon-arrow-down': isShowCurriculumInformation }]"
              @click="isShowCurriculumInformation = !isShowCurriculumInformation">&nbsp;{{ isShowCurriculumInformation ? '收起' : '展开' }}
        </span>
      </p>
      <div v-show="isShowCurriculumInformation">
        <!-- 文本区 -->
        <div style="padding-left: 20px;">
          <template v-for="(curriculumItem, curriculumIndex) in trainerCurriculumDTOList">
            <el-row :key="curriculumIndex"
                    style="margin: 20px 0;"
                    :gutter="0">
              <el-col :span="20">
                <div style="cursor: pointer;"
                      v-show="trainerCurriculumDTOList.length !== 1 && isShowCurriculum"
                      @click="curriculumDelete(curriculumIndex)"><em class="el-icon-remove"
                      style="color : red;">删除本项</em>
                </div>
                <br>
                <el-input type="textarea"
                          v-show="trainerCurriculumDTOList[curriculumIndex].curriculumType === '1'"
                          :disabled="isCurriculumContent"
                          placeholder="请介绍培训师的主讲课程(限制输入500字)"
                          v-model="trainerCurriculumDTOList[curriculumIndex].curriculumContent"
                          maxlength="500"
                          show-word-limit
                          class="briefContent">
                </el-input>
                <div v-show="trainerCurriculumDTOList[curriculumIndex].curriculumType === '2'">
                  <img alt="" :src="trainerCurriculumDTOList[curriculumIndex].imgAddr"
                        style="width: 220px;height: 100px;" alt="trainerImg"/>
                </div>
              </el-col>
              <el-col :span="4">
                <div style="cursor: pointer;"
                      v-show="curriculumIndex !== 0 && isShowCurriculumMove"
                      @click="curriculumMoveUpward(curriculumIndex)"><em class="el-icon-caret-top">上移</em>
                </div>
                <br>
                <div style="cursor: pointer;"
                      v-show="isShowCurriculumMove && trainerCurriculumDTOList.length !== curriculumIndex+1"
                      @click="curriculumMoveDown(curriculumIndex)"><em class="el-icon-caret-bottom">下移</em>
                </div>
              </el-col>
            </el-row>
          </template>
        </div>
        <!-- 按钮区 -->
        <div>
          <el-row :gutter="0">
            <el-col :span="3"
                    class="query-button">
              <!--增加文本-->
              <el-button class="M-search"
                          style="padding-left: 10px;width:120px "
                          v-show="isShowCurriculum"
                          size="small"
                          type="primary"
                          @click="addCurriculum()">{{ $t('trainer.brief') }}</el-button>&nbsp;
            </el-col>
            <el-col :span="3"
                    class="query-button">
              <el-col :span="24">
                <el-upload v-show="isShowCurriculum"
                            class="upload-demo"
                            :headers="headers"
                            :action="actionUrl"
                            accept=".jpg,.png"
                            :before-remove="uploadBeforeRemove"
                            multiple
                            :file-list="curriculumFileList"
                            :on-success="submitUploadCurriculumSuccess"
                            :limit="1"
                            :on-exceed="handleExceed"
                            :beforeUpload="beforeAvatarUpload">
                  <el-button class="M-search"
                              style="width: 110px"
                              size="small"
                              type="primary">{{'上传文件'}}</el-button>
                </el-upload>
              </el-col>
            </el-col>
            <el-col :span="15">
              <el-col :span="24">
                <div style="text-align: left;font-size: 12px;color: darkgray; height: 40px; line-height: 35px;" v-show="isShowCurriculum">{{'建议尺寸比例2.2:1，不超过4M，格式为jpg，png'}}</div>
              </el-col>
            </el-col>
            <el-col :span="24">
              <div class="btn-position-up"
                    style="text-align:right; margin-right: 15px;">
                <!-- 保存按钮 -->
                <el-button type="primary"
                            v-show="isShowCurriculum"
                            :loading="dataListLoading"
                            @click="curriculumSubmitHandle()">{{ $t('trainer.save') }}</el-button>
                <!-- 返回按钮 -->
                <el-button type="info"
                            v-show="isShowCurriculum"
                            @click="backcurriculumPage()">{{ $t('trainer.close') }}</el-button>
                <!-- 编辑按钮 -->
                <el-button type="primary"
                            v-show="isShowCurriculumUpdate && $hasPermission('AUTHTRAINER0005')&&!disabledEdit"
                            @click="curriculumUpdate()">{{'编辑'}}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>
    <!-- 其他 -->
    <section class="pkg-search-box pkg-content pkg-module">
      <p class="pkg-content-title">其他
        <span :class="['show-or-hide', { 'el-icon-arrow-up': isShowOtherInformation,'el-icon-arrow-down': isShowOtherInformation }]"
              @click="isShowOtherInformation = !isShowOtherInformation">&nbsp;{{ isShowOtherInformation ? '收起' : '展开' }}
        </span>
      </p>
      <div v-show="isShowOtherInformation">
        <!-- 文本区 -->
        <div style="padding-left: 20px;">
          <template v-for="(otherItem, otherIndex) in trainerOtherDTOList">
            <el-row :key="otherIndex"
                    style="margin: 20px 0;"
                    :gutter="0">
              <el-col :span="20">
                <div style="cursor: pointer;"
                      v-show="isShowOther"
                      @click="otherDelete(otherIndex)"><em class="el-icon-remove"
                      style="color : red;">删除本项</em>
                </div>
                <br>
                <el-input type="textarea"
                          v-show="trainerOtherDTOList[otherIndex].otherType === '1'"
                          :disabled="isOtherContent"
                          placeholder="请输入内容(限制输入500字)"
                          v-model="trainerOtherDTOList[otherIndex].otherContent"
                          maxlength="500"
                          show-word-limit
                          class="briefContent">
                </el-input>
                <div v-show="trainerOtherDTOList[otherIndex].otherType === '2'">
                  <img alt="" :src="trainerOtherDTOList[otherIndex].imgAddr"
                        style="width: 220px;height: 100px;" alt="trainerImg"/>
                </div>
              </el-col>
              <el-col :span="4">
                <div style="cursor: pointer;"
                      v-show="otherIndex !== 0 && isShowOtherMove"
                      @click="otherMoveUpward(otherIndex)"><em class="el-icon-caret-top">上移</em>
                </div>
                <br>
                <div style="cursor: pointer;"
                      v-show="trainerOtherDTOList.length !== otherIndex+1 && isShowOtherMove"
                      @click="otherMoveDown(otherIndex)"><em class="el-icon-caret-bottom">下移</em>
                </div>
              </el-col>
            </el-row>
          </template>
        </div>
        <!-- 按钮区 -->
        <div>
          <el-row :gutter="0">
            <el-col :span="3"
                    class="query-button">
              <!--增加文本-->
              <el-button class="M-search"
                          v-show="isShowOther"
                          style="padding-left: 10px;width:120px "
                          size="small"
                          type="primary"
                          @click="addOther()">{{ $t('trainer.brief') }}</el-button>&nbsp;
            </el-col>
            <el-col :span="3"
                    class="query-button">
                <el-upload v-show="isShowOther"
                            class="upload-demo"
                            :headers="headers"
                            :action="actionUrl"
                            accept=".jpg,.png"
                            :before-remove="uploadOtherRemove"
                            multiple
                            :file-list="otherFileList"
                            :on-success="submitUploadOtherSuccess"
                            :limit="1"
                            :on-exceed="handleExceed"
                            :beforeUpload="beforeAvatarUpload">
                  <el-button class="M-search"
                              size="small"
                              style="width: 110px"
                              type="primary">{{'上传文件'}}</el-button>
                </el-upload>
            </el-col>
            <el-col :span="18">
              <el-col :span="24">
                <div style="text-align: left;font-size: 12px;color: darkgray; height: 40px; line-height: 35px;" v-show="isShowOther">{{'建议尺寸比例2.2:1，不超过4M，格式为jpg，png'}}</div>
              </el-col>
            </el-col>
          </el-row>
        </div>
        <div style="padding-left: 20px;">
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="btn-position-up btn-position-right"
                    style="margin-right: 15px;">
                <!-- 保存按钮 -->
                <el-button type="primary"
                            v-show="isShowOther"
                            :loading="dataListLoading"
                            @click="otherSubmitHandle()">{{ $t('trainer.save') }}</el-button>
                <!-- 返回按钮 -->
                <el-button type="info"
                            v-show="isShowOther"
                            @click="backotherPage()">{{ $t('trainer.close') }}</el-button>
                <!-- 编辑按钮 -->
                <el-button type="primary"
                            v-show="isShowOtherUpdate && $hasPermission('AUTHTRAINER0005')&&!disabledEdit"
                            @click="otherUpdate()">{{'编辑'}}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AddOrUpdate from './trainerinformation-add-or-update'
import ClassTree from '@/components/rm/class-tree/index'
import UploadFile from '@/components/rm/upload-file/index'
import Tag from '@/components/rm/label-select/index'
import VueI18n from '@/i18n'
import Vue from 'vue'
import dayjs from 'dayjs'
export default {
  components: {
    Tag,
    AddOrUpdate,
    'class-tree': ClassTree,
    'upload-file': UploadFile
  },
  data () {
    // 校验输入的数字为正整数
    let integerVali = (rule, value, callback) => {
      if (!value) {
        return callback()
      }
      let reg = /^\d+$/
      if (!reg.test(value)) {
        callback(new Error(this.$t('trainer.nonnegativeInteger')))
      } else {
        callback()
      }
    }
    return {
      // 团队分类是否可编辑
      isGroupTypeU: false,
      isGroupTypeV: true,
      showGroupTypeList:[],
      showgroupTypeName: '',
      // 性别
      sexType: this.enums['sex'],
      userorgType: this.enums['orgType'],
      checkList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: 7,
      bussinessTypeChecked: null,
      // 上传地址
      actionUrl: window.SITE_CONFIG['apiBaseURL'] + '/sys/config/imgUpload',
      // actionUrl: 'http://joylearning.bmw.bmw.com.cn:9090/sys/config/imgUpload',
      isShowHierarchicalInformation: true,
      isShowLabelInformation: true,
      isShowBriefInformation: true,
      isShowCurriculumInformation: true,
      isShowOtherInformation: true,
      isShowContract: true,
      // 防止重复提交
      dataListLoading: false,
      addListLoading: false,
      isShowUser: false,
      annualTabName: 'tab0',
      // 团队分类
      groupTypeArr: this.enums['teaTeamClass'],
      // 所在城市不可编辑
      isCity: true,
      // 等级信息不可编辑
      isHierarchicalInformation: true,
      // 简介信息不可编辑
      isBriefContent: true,
      isCurriculumContent: true,
      isOtherContent: true,
      // 基础信息保存，返回按钮是否显示
      isShowDataForm: false,
      // 基础信息编辑是否显示
      isShowDataFormUpdate: true,
      // 等级信息新增保存，返回按钮是否显示
      isShowSaveInsert: false,
      // 等级信息保存，返回按钮是否显示
      isShowHierarchical: false,
      // 等级信息编辑是否显示
      isShowHierarchicalUpdate: true,
      // 简介信息编辑按钮是否显示
      isShowBriefUpdate: true,
      isShowCurriculumUpdate: true,
      isShowOtherUpdate: true,
      // 简介信息保存，返回按钮是否显示
      isShowBrief: false,
      isShowCurriculum: false,
      isShowOther: false,
      // 简介信息删除按钮是否显示
      isShowDelete: false,
      isShowCurriculumDelete: false,
      // 标签保存，返回按钮是否显示
      isShowLabel: false,
      // 标签编辑按钮是否显示
      isShowLabelUpdate: true,
      // 上下移动按钮是否显示
      isShowMove: false,
      isShowCurriculumMove: false,
      isShowOtherMove: false,
      // 培训师状态
      statusArr: this.enums['status'],
      // 是否
      confirmStateArr: this.enums['confirmState'],
      // 级别
      qualityLevelArr: this.enums['qualityLevel'],
      // 培训师角色
      trainerRoleArr: this.enums['trainerRole'],
      // 年度
      annualArr: [{ name: new Date().getFullYear(), code: new Date().getFullYear() }, { name: new Date().getFullYear() + 1, code: new Date().getFullYear() + 1 }],
      // 团队分类
      defaultProps: {
        children: 'children',
        label: 'treamCnName'
      },
      queryTreeUrl: '/rm/rpc/treamClassTree/list',
      // 主页面城市树
      queryCityTreeUrl: '/rm/courseclassroomrela/queryregiontree',
      citydefaultProps: {
        children: 'childrenRegionList',
        label: 'regionNameCn'
      },
      dataForm: {
        id: '',
        userName: '',
        firstNameCn: '',
        userNameCn: '',
        lastNameEn: '',
        userCardNo: '',
        email: '',
        mobile: '',
        birthday: '',
        sexCode: '',
        orgId: '',
        abbreviationCn: '',
        bmwDeptCode: '',
        orgType: '',
        orgJoinDate: '',
        trainerNo: '',
        trialEndDate: '',
        labelId: '',
        city: '',
        trainerStatus: '',
        hasTencentMeetingAccount: '',
        position: '',
        showCityValue: '',
        showCityClassList: []
      },
      // 等级信息
      trainerAnnualTargetDTOList: [],
      fileList: [],
      curriculumFileList: [],
      otherFileList: [],
      // 简介信息
      trainerBriefDTOList: [],
      trainerCurriculumDTOList: [],
      trainerOtherDTOList: [],
      contractLevelList: [],
      contractList: [],
      disabledLevel: false,
      // 点击年度信息编辑获取的下标
      trainerTargetIndex: undefined,
      originBeginTime: '',
      originEndTime: '',
      dataFormRule: {
        city: [
          { required: true, message: this.$t("trainer.citySave"), trigger: "change" },
        ],
        trainerStatus: [
          { required: true, message: this.$t("trainer.trainerStatusSave"), trigger: "change" },
        ],
        position: [
          { required: true, message: this.$t("trainer.positionSave"), trigger: "blur" },
        ],
      },
      targetRule: {
        groupType: [
          { required: true, message: this.$t("trainer.groupTypeSave"), trigger: "blur" },
        ],
        trainerRole: [
          { required: true, message: this.$t("trainer.groupTypeSave"), trigger: "change" },
        ],
        taLevel: [
          { required: true, message: this.$t("trainer.taLevelSave"), trigger: "change" },
        ],
        isBest: [
          { required: true, message: this.$t("trainer.isBestSave"), trigger: "change" },
        ],
        annual: [
          { required: true, message: this.$t("trainer.annualSave"), trigger: "change" },
        ],
        target: [
          { required: true, message: this.$t('trainer.targetSave'), trigger: 'blur' },
          { validator: integerVali, trigger: 'blur' }
        ]
      },
      historyRule: {
        beginTime: [
          { required: true, message: this.$t("contract.historyBeginTime"), trigger: "change" }
        ]
      },
      contractHistoryList: [],
      historyIndex: 0,
      historyName: 'contractO',
      isHistory: false,
      isShowHistoryInsert: false,
      isNewContract: false,
      noContract: false,
      disabledAddContract: false,
      saveLoading: true,
      pickerOptions2: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.originBeginTime).getTime() || time.getTime() > new Date(this.originEndTime).getTime()
        }
      },
      disablePermissionNodes: true,
      groupName: '',
      disabledEdit: true
    }
  },
  mounted () {
    this.gitpush()
    this.queryDataList()
    this.contractList = []
    this.contractHistoryList = []
    this.$eventHub.$on(this.GLOBAL.TRAINER_INFO, () => {
      this.disabledLevel = false
      this.contractList = []
      this.contractHistoryList = []
      this.contractLevelList =  []
      this.originBeginTime = ''
      this.originEndTime = ''
      this.queryDataList()
    })
  },
  destroyed() {
    this.dataForm.trainerId = ''
    this.$refs.targetForm[0].clearValidate()
  },
  computed: {
    // 获取请求头
    headers: function headers () {
      return {
        token: Vue.prototype.getStorage(Vue.prototype.GLOBAL.TOKEN)
      }

    },
    hasTencentMeetingAccount() {
      return this.dataForm.hasTencentMeetingAccount === 0 ? this.$t('trainer.no') : this.$t('trainer.yes')
    }
  },
  methods: {
    gitpush(value){
      // console.log('')
      // this.hasTencentMeetingAccount(value);
      // if(this.hasTencentMeetingAccount(value) === null){
      //   return value = push("否")
      // }
    },
    addHistory () {
      const params = {
        contractNo: '',
        trainerLevelKey: null,
        beginTime: '',
        isShow: true
      }
      this.isNewContract = true
      this.contractHistoryList.unshift(params)
      this.isShowHistoryInsert = true
      this.historyIndex = 0
      this.historyName = 'contract0'
      this.contractHistoryList = this.contractHistoryList.map((item, index) => {
        return { ...item, isShow: index!==0 }
      })
      this.getContractList(this.dataForm.orgId)
      this.$nextTick(() => {
        this.$refs.historyForm[0].clearValidate()
      })
    },
    saveHistory (index) {
      this.$confirm(this.$t('contract.sureSaveContract'),this.$t("prompt.title"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning",
      }).then(() => {
        this.$refs.historyForm[index].validate((valid) => {
          if (valid) {
            this.dataForm.labelId = this.checkList.map(item => item.labelId).join(',')
            this.contractHistoryList = this.contractHistoryList.map((item) => {
              if (item.endTime) {
                delete item.endTime
              }
              return { ...item, trainerLevelKey: item.trainerLevelKey === this.$t('contract.noLevel') ? '' : item.trainerLevelKey, beginTime: dayjs(item.beginTime).format('YYYY-MM-DD') + ' 00:00:00' }
            })
            const params = {
              ...this.dataForm,
              trainerAnnualTargetDTOList: this.trainerAnnualTargetDTOList,
              trainerBriefDTOList: this.trainerBriefDTOList,
              trainerCurriculumDTOList: this.trainerCurriculumDTOList,
              trainerOtherDTOList: this.trainerOtherDTOList,
              trainerContractList: this.contractHistoryList
            }
            this.saveLoading = true
            // 判断是否生效版本后面还有版本
            this.$request.post(`/rm/trainer/checkVersion?time=${this.contractHistoryList[0].beginTime}&id=${this.dataForm.id}`).then((res) => {
              if (res && res.length > 0) {
                const length = this.contractHistoryList.length
                let version = []
                this.contractHistoryList.forEach((ktem, k) => {
                  if (res.includes(ktem.id)) {
                    version.unshift(length - k)
                  }
                })
                this.saveHistoryFinal(params)
                this.$confirm(this.$t("contract.historyContratInfoInfo", { 'handle': version.toString() }) , this.$t("prompt.title"), {
                  showConfirmButton: true,
                  showCancelButton: false,
                })
              } else {
                this.saveHistoryFinal(params)
              }
            }).catch(() => {
              this.saveLoading = false
            })
          }
        })
      })
    },
    saveHistoryFinal (params) {
      this.$request.post('/rm/trainer/saveTrainer', params).then(() => {
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 300
        })
        this.isShowHistoryInsert = false
        this.contractHistoryList = this.contractHistoryList.map((item) => {
          return { ...item, isShow: false }
        })
        this.queryDataList()
      })
    },
    backHistoryEdit () {
      this.isShowHistoryInsert = false
      this.contractHistoryList = this.contractHistoryList.map((item) => {
        return { ...item, isShow: false }
      })
      this.saveLoading = true
      if (this.isNewContract) {
        this.contractHistoryList.shift()
      }
      this.queryDataList()
    },
    cityclassInfo (listName) {
      if(listName === 'city'){
        this.dataForm.city = ''
      }
    },
    groupType (listName){
      if(listName === 'groupType'){
        this.trainerAnnualTargetDTOList[this.trainerTargetIndex].groupType = ''
      }
    },
    getBussinessType (val) {
      this.dataForm.bussinessTypeId = val
      this.bussinessTypeId = val
    },
    changeCheckedList (array) {
      this.checkList = array
    },
    // 重新勾选业务标签
    fatherMethod () {
      this.checkList = this.dataForm.commLabelVoList || []
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        this.checkList = this.checkList.filter((item) => item.labelNameCn).map((o) => {
          return { ...o, abelName: o.labelNameCn }
        })
      } else {
        this.checkList = this.checkList.filter((item) => item.labelNameEn).map((o) => {
          return { ...o, labelName: o.labelNameEn }
        })
      }
    },
    queryDataList () {
      this.$nextTick(() => {
        this.dataForm.trainerId = this.$route.query.id
        this.getInfo()
      })
    },
    // 加载页面时赋值
    getInfo () {
      this.disabledAddContract = true
      this.isShowHistoryInsert = false
      this.$request.get(`/rm/trainer/info`, { trainerId: this.dataForm.trainerId }).then((res) => {
        const keys = ['id', 'userName', 'trainerNo', 'userCardNo', 'trialEndDate', 'city', 'position', 'trainerStatus']
        const keysComm = ['firstNameCn', 'userNameCn', 'email', 'mobile', 'birthday', 'sexCode', 'orgId', 'abbreviationCn', 'bmwDeptCode', 'orgType']
        keys.forEach((item) => {
          this.dataForm[item] = res[item]
        })
        keysComm.forEach((item) => {
          this.dataForm[item] = res.commOutUserDTO[item]
        })
        this.dataForm.lastNameEn = res.commOutUserDTO.lastNameCn
        this.dataForm.orgJoinDate = res.commOutUserDTO.jobcodeJoinDate
        this.dataForm.hasTencentMeetingAccount = res.hasTencentMeetingAccount
        // 城市分类的回填
        this.dataForm.showCityValue = res.cityName
        this.dataForm.showCityClassList = [res.city]
        this.trainerAnnualTargetDTOList = res.trainerAnnualTargetDTOList.sort((a, b) => { return b.annual - a.annual }).map((item) => {
          return { ...item, isShow: false }
        })
        let nowIndex = 0
        this.contractHistoryList = res.trainerContractList.map((item, index) => {
          if (item.version) {
            nowIndex = index
          }
          return { ...item, isShow: false , trainerLevelKey: item.trainerLevelKey ? item.trainerLevelKey*1 : this.$t('contract.noLevel') }
        })
        this.historyName = 'contract' + nowIndex
        this.saveLoading = false
        this.disabledAddContract = false
        this.historyIndex = nowIndex
        this.getContractList(this.dataForm.orgId)
        this.trainerBriefDTOList = res.trainerBriefDTOList
        this.trainerCurriculumDTOList = res.trainerCurriculumDTOList
        this.trainerOtherDTOList = res.trainerOtherDTOList
        // 已选择的标签
        this.checkList = res.commLabelVoList || []
        this.dataForm.commLabelVoList = res.commLabelVoList
        if (VueI18n.locale === 'zh-CN') {
            this.checkList = this.checkList.filter((item) => item.labelNameCn).map((o) => {
              return { ...o, labelName: o.labelNameCn }
            })
          } else {
            this.checkList = this.checkList.filter((item) => item.labelNameEn).map((o) => {
              return { ...o, labelName: o.labelNameEn }
            })
          }
        // 赋值标签id
        this.dataForm.labelId = this.checkList.map(item => item.labelId).join(',')
        // 团队分类
        if (this.trainerAnnualTargetDTOList.length === 0) {
          this.disablePermissionNodes = false
        } else {
          this.groupName = this.trainerAnnualTargetDTOList[0].groupTypeName.replace(',', '_')
          if (JSON.parse(sessionStorage.getItem("v1user_data")).userCode === "admin") {
            this.disabledEdit = false
          } else {
            this.disabledEdit = !this.$hasPermission('SC_TRAINER_ADD:' + this.groupName)
          }
          console.log(this.disabledEdit, this.groupName)
        }
      })
    },
    // 获取该组织下的合同列表
    getContractList (val) {
      this.$request.get(`/rm/trainer/queryContractLevels?orgId=${val}`).then((res) => {
        if (res) {
          this.contractLevelList = []
          if (res.length > 0) {
             this.contractList = res.map((item) => {
               return { contractNoName: item.contractNo, contractNo: item.contractNo, expensesList: item.expensesList, beginTime: item.beginTime, endTime: item.endTime }
             })
            this.$set(this.historyRule, 'contractNo', [{ required: true, message: this.$t("contract.trainerContractTypeValid"), trigger: "change" }])
            this.noContract = false
          } else {
            this.contractList = [{contractNoName: this.$t('contract.noContract') , contractNo: ''}]
            this.disabledLevel = true
            this.$set(this.historyRule, 'contractNo', [{ required: false }])
            this.$set(this.historyRule, 'trainerLevelKey', [{ required: false }])
            this.contractLevelList = [{name: this.$t('contract.noLevel'), code: this.$t('contract.noLevel') }]
            this.noContract = true
          }
          if (this.$refs.historyForm) {
             this.$refs.historyForm[0].clearValidate()
          }
          const obj = this.contractHistoryList[this.historyIndex]
          if (obj && obj.contractNo) {
            this.changeContract(obj.contractNo, true)
          }
        }
      })
    },

    // 切换tab 重置校验
    changeTab (tab) {
      this.historyIndex = tab.index
      this.disabledLevel = this.contractHistoryList[tab.index].contractNo ? false : true
      this.changeContract(this.contractHistoryList[tab.index].contractNo, true)
      this.$refs.historyForm[tab.index].clearValidate()
    },
    changeContract (val, type) {
      const [obj] = [...this.contractList.filter((item) => item.contractNo === val )]
      let index = this.historyIndex
      const arr = this.enums['contractTrainerLevel']
      if (obj) {
        this.originBeginTime = obj.beginTime
        this.originEndTime = obj.endTime
      }
      if (!type && obj) {
        this.$set(this.contractHistoryList[index], 'beginTime', obj.beginTime)
      }
      if (this.contractHistoryList[index].trainerLevelKey === null) {
        this.contractHistoryList[index].trainerLevelKey = ''
      }
      let data = []
      if (!type) {
        if (obj.expensesList && obj.expensesList.length>0) {
          this.$set(this.contractHistoryList[index], 'trainerLevelKey', '')
        } else {
          this.$set(this.contractHistoryList[index], 'trainerLevelKey', this.$t('contract.noLevel'))
        }
      }
      if (obj && obj.expensesList) {
        data = obj.expensesList.map((item) => {
          let sobj = {}
          for(let i of arr) {
            if (item.trainerLevelKey*1 === i.code*1) {
              sobj.name = i.name
              sobj.code = i.code
            }
          }
          return sobj
        })
      }
      if (data.length === 0) {
        this.disabledLevel = true
        this.$set(this.historyRule, 'trainerLevelKey', [{ required: false }])
        this.contractLevelList = [{name: this.$t('contract.noLevel'), code: this.$t('contract.noLevel') }]
        this.$refs.historyForm[index].clearValidate()
      } else {
        this.contractLevelList = data
        this.disabledLevel = false
        this.$set(this.historyRule, 'trainerLevelKey', [{ required: true, message: this.$t("contract.trainerContractLevelValid"), trigger: "change" }])
        if (this.contractHistoryList[index].trainerLevelKey === this.$t('contract.noLevel')) {
          this.$set(this.contractHistoryList[index], 'trainerLevelKey', '')
        }
      }
      this.$nextTick(() => {
        this.$refs.historyForm[index].clearValidate()
      })
    },
    // 基础信息编辑方法
    dataFormUpdate () {
      this.isShowDataForm = true
      this.isShowDataFormUpdate = false
      this.isCity = false
    },
    // 基础信息保存表单提交
    dataFormSubmitHandle () {
      this.dataListLoading = true
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$request.post('/rm/trainer/saveTrainer', this.dataForm).then(() => {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.dataListLoading = false
                this.isShowDataForm = false
                this.isShowDataFormUpdate = true
                this.isCity = true
              }
            })
          })
        } else {
          this.dataListLoading = false
          return false
        }
      })
    },
    // 关闭按钮
    backDataFormPage () {
      this.isShowDataForm = false
      this.isShowDataFormUpdate = true
      this.isCity = true
      this.queryDataList()
    },
    // 等级信息新增
    async hierarchicalInsert () {
      this.isShowSaveInsert = true
      this.isShowHierarchicalUpdate = false
      this.isHierarchicalInformation = false
      this.isGroupTypeV = false
      this.isGroupTypeU = true
      this.$refs.targetForm[0].clearValidate()
      await this.$request.get(`/rm/trainer/newTrainerAnnualTarget`, { trainerId: this.dataForm.id }).then((res) => {
        this.trainerAnnualTargetDTOList.unshift({ ...res, isShow: false })
      })
      for (let item = 0; item < this.trainerAnnualTargetDTOList.length; item++) {
        this.trainerAnnualTargetDTOList[item].isShow = true
        if (item === 0) {
          this.trainerTargetIndex = item
          this.trainerAnnualTargetDTOList[item].isShow = true
          this.disabledLevel = this.trainerAnnualTargetDTOList[item].contractNo ? false : true
          this.showGroupTypeList = [this.trainerAnnualTargetDTOList[item].groupType]
          this.showgroupTypeName = this.trainerAnnualTargetDTOList[item].groupTypeName
        }
      }
      this.annualTabName = 'tab0'
      this.$forceUpdate()
    },
    // 等级信息新增返回
    hierarchicalCloseInsert () {
      // 等级信息新增保存，返回按钮是否显示
      this.isShowSaveInsert = false
      // 等级信息保存，返回按钮是否显示
      this.isShowHierarchical = false
      // 等级信息编辑是否显示
      this.isShowHierarchicalUpdate = true
      this.isHierarchicalInformation = true
      this.isGroupTypeV = true
      this.isGroupTypeU = false
      this.trainerAnnualTargetDTOList = this.trainerAnnualTargetDTOList.map((item) => {
        return { ...item, isShow: false }
      })
      this.queryDataList()
      this.$refs.targetForm[0].clearValidate()
    },
    // 等级信息编辑
    hierarchicalUpdate (index) {
      // 点击编辑时获取的下标
      this.trainerTargetIndex = index
      this.isShowHierarchical = true
      this.isShowHierarchicalUpdate = false
      this.isHierarchicalInformation = false
      this.isGroupTypeV = false
      this.isGroupTypeU = true
      this.showGroupTypeList = []
      this.showgroupTypeName = ''
      this.showGroupTypeList.push(this.trainerAnnualTargetDTOList[index].groupType)
      this.showgroupTypeName = this.trainerAnnualTargetDTOList[index].groupTypeName
      this.trainerAnnualTargetDTOList = this.trainerAnnualTargetDTOList.map((item, indexs) => {
        return { ...item, isShow: index !== indexs }
      })
    },
    // 等级信息保存表单提交
    hierarchicalSubmitHandle (index) {
      this.$confirm('您确定保存吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs['targetForm'][index].validate((valid) => {
          if (valid) {
            this.dataListLoading = true
            const param = {
              ...this.dataForm,
              'trainerAnnualTargetDTO': this.trainerAnnualTargetDTOList[index],
              'trainerBriefDTOList': this.trainerBriefDTOList,
              'trainerCurriculumDTOList': this.trainerCurriculumDTOList,
              'trainerOtherDTOList': this.trainerOtherDTOList
            }
            this.$request.post('/rm/trainer/saveTrainerAnnualTarget', param).then(() => {
              this.$message.success(this.$t('prompt.success'))
              this.trainerAnnualTargetDTOList = this.trainerAnnualTargetDTOList.map((item) => {
                return { ...item, isShow: false }
              })
              this.isShowSaveInsert = false
              this.isShowHierarchical = false
              this.isShowHierarchicalUpdate = true
              this.isHierarchicalInformation = true
              this.isGroupTypeV = true
              this.isGroupTypeU = false
              this.dataListLoading = false
              this.queryDataList()
            }).catch(() => {
              this.dataListLoading = false
            })
          } else {
            return false
          }
        })
      })
    },
    // 等级信息关闭按钮
    backHierarchicalPage () {
      this.isShowHierarchical = false
      this.isShowHierarchicalUpdate = true
      this.isHierarchicalInformation = true
      this.isGroupTypeV = true
      this.isGroupTypeU = false
      this.trainerAnnualTargetDTOList = this.trainerAnnualTargetDTOList.map((item) => {
        return  { ...item, isShow: false}
      })
      this.queryDataList()
    },
    // 标签编辑
    labelUpdate(){
      this.isShowLabelUpdate = false
      this.isShowLabel = true
    },
    // 标签保存
    labelSubmitHandle(){
      this.dataForm.labelId = this.checkList.map(item => item.labelId).join(',')
      // 控制保存按钮，防止重复点击保存
      this.dataListLoading = true
      const param = {
        ...this.dataForm
      }
      this.$request.post('/rm/trainer/saveTrainer', param).then(() => {
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.dataListLoading = false
            this.isShowLabelUpdate = true
            this.isShowLabel = false
            this.queryDataList()
          }
        })
      })
    },
    // 标签返回
    backlabelPage(){
      this.isShowLabelUpdate = true
      this.isShowLabel = false
    },
    // 简介信息编辑
    briefUpdate () {
      this.isShowBriefUpdate = false
      this.isShowBrief = true
      this.isBriefContent = false
      this.isShowDelete = true
      this.isShowMove = true
    },
    curriculumUpdate () {
      this.isShowCurriculum = false
      this.isShowCurriculumDelete = true
      this.isShowCurriculum = true
      this.isCurriculumContent = false
      this.isShowCurriculumUpdate = false
      this.isShowCurriculumMove = true
    },
    otherUpdate () {
      this.isShowOther = false
      this.isShowCurriculumDelete = true
      this.isShowOther = true
      this.isOtherContent = false
      this.isShowOtherUpdate = false
      this.isShowOtherMove = true
    },
    // 简介信息保存
    briefSubmitHandle () {
      let _this = this
      // 控制保存按钮，防止重复点击保存
      _this.dataListLoading = true
      for (let i = 0; i < _this.trainerBriefDTOList.length; i++) {
        if (_this.trainerBriefDTOList[i].briefType === '1') {
          if (!_this.trainerBriefDTOList[i].briefContent) {
            _this.dataListLoading = false
            _this.$message.warning(_this.$t('trainer.briefContent'))
            return false
          }
        }
      }
      let url = ''
      let param = ''
      url = '/rm/trainer/updateTrainer'
      param = {
        ..._this.dataForm,
        'trainerAnnualTargetDTOList': _this.trainerAnnualTargetDTOList,
        'trainerBriefDTOList': _this.trainerBriefDTOList,
        'trainerCurriculumDTOList': _this.trainerCurriculumDTOList,
        'trainerOtherDTOList': _this.trainerOtherDTOList
      }
      _this.$request.post(
        url, param
      ).then((data) => {
        _this.$message({
          message: _this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.dataListLoading = false
            this.isShowBriefUpdate = true
            this.isShowBrief = false
            this.isBriefContent = true
            this.isShowDelete = false
            this.isShowMove = false
            this.queryDataList()
          }
        })
      })
    },
    curriculumSubmitHandle () {
      let _this = this
      // 控制保存按钮，防止重复点击保存
      _this.dataListLoading = true
      for (let j = 0; j < _this.trainerCurriculumDTOList.length; j++) {
        if (_this.trainerCurriculumDTOList[j].curriculumType === '1') {
          if (!_this.trainerCurriculumDTOList[j].curriculumContent) {
            _this.dataListLoading = false
            _this.$message.warning(_this.$t('trainer.curriculumContent'))
            return false
          }
        }
      }
      let url = ''
      let param = ''
      url = '/rm/trainer/updateCurriculum'
      param = {
        ..._this.dataForm,
        'trainerAnnualTargetDTOList': _this.trainerAnnualTargetDTOList,
        'trainerBriefDTOList': _this.trainerBriefDTOList,
        'trainerCurriculumDTOList': _this.trainerCurriculumDTOList,
        'trainerOtherDTOList': _this.trainerOtherDTOList
      }
      _this.$request.post(
        url, param
      ).then((data) => {
        _this.$message({
          message: _this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.dataListLoading = false
            this.isShowCurriculum = true
            this.isShowCurriculumDelete = false
            this.isShowCurriculum = false
            this.isCurriculumContent = true
            this.isShowCurriculumUpdate = true
            this.isShowCurriculumMove = false
            this.queryDataList()
          }
        })
      })
    },
    otherSubmitHandle () {
      let _this = this
      // 控制保存按钮，防止重复点击保存
      _this.dataListLoading = true
      for (let h = 0; h < _this.trainerOtherDTOList.length; h++) {
        if (_this.trainerOtherDTOList[h].otherType === '1') {
          if (!_this.trainerOtherDTOList[h].otherContent) {
            _this.dataListLoading = false
            _this.$message.warning(_this.$t('trainer.otherContent'))
            return false
          }
        }
      }
      let url = ''
      let param = ''
      url = '/rm/trainer/updateOther'
      param = {
        ..._this.dataForm,
        'trainerAnnualTargetDTOList': _this.trainerAnnualTargetDTOList,
        'trainerBriefDTOList': _this.trainerBriefDTOList,
        'trainerCurriculumDTOList': _this.trainerCurriculumDTOList,
        'trainerOtherDTOList': _this.trainerOtherDTOList
      }
      _this.$request.post(
        url, param
      ).then((data) => {
        _this.$message({
          message: _this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.dataListLoading = false
            this.isShowOther = true
            this.isShowCurriculumDelete = false
            this.isShowOther = false
            this.isOtherContent = true
            this.isShowOtherUpdate = true
            this.isShowOtherMove = false
            this.queryDataList()
          }
        })
      })
    },
    // 简介信息返回
    backbriefPage () {
      this.isShowBriefUpdate = true
      this.isShowBrief = false
      this.isBriefContent = true
      this.isShowDelete = false
      this.isShowMove = false
      this.queryDataList()
    },
    backcurriculumPage () {
      this.isShowCurriculum = true
      this.isShowCurriculumDelete = false
      this.isShowCurriculum = false
      this.isCurriculumContent = true
      this.isShowCurriculumUpdate = true
      this.isShowCurriculumMove = false
      this.queryDataList()
    },
    backotherPage () {
      this.isShowOther = true
      this.isShowCurriculumDelete = false
      this.isShowOther = false
      this.isOtherContent = true
      this.isShowOtherUpdate = true
      this.isShowOtherMove = false
      this.queryDataList()
    },
    // 简介信息单条删除
    briefDelete (briefIndex) {
      let _this = this
      if (this.trainerBriefDTOList[briefIndex].id === '' || this.trainerBriefDTOList[briefIndex].id === null || this.trainerBriefDTOList[briefIndex].id === undefined) {
        _this.trainerBriefDTOList.splice(briefIndex, 1)
      } else {
        let url = ''
        url = '/rm/trainer/deleteTrainerBrief'
        _this.$request.post(
          url, _this.trainerBriefDTOList[briefIndex]
        ).then(() => {
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              _this.trainerBriefDTOList.splice(briefIndex, 1)
            }
          })
        })
      }
    },
    curriculumDelete (curriculumIndex) {
      let _this = this
      if (this.trainerCurriculumDTOList[curriculumIndex].id === '' || this.trainerCurriculumDTOList[curriculumIndex].id === null || this.trainerCurriculumDTOList[curriculumIndex].id === undefined) {
        _this.trainerCurriculumDTOList.splice(curriculumIndex, 1)
      } else {
        let url = ''
        url = '/rm/trainer/deleteTrainerCurriculum'
        _this.$request.post(
          url, _this.trainerCurriculumDTOList[curriculumIndex]
        ).then(() => {
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              _this.trainerCurriculumDTOList.splice(curriculumIndex, 1)
            }
          })
        })
      }
    },
    otherDelete (otherIndex) {
      let _this = this
      if (this.trainerOtherDTOList[otherIndex].id === '' || this.trainerOtherDTOList[otherIndex].id === null || this.trainerOtherDTOList[otherIndex].id === undefined) {
        _this.trainerOtherDTOList.splice(otherIndex, 1)
      } else {
        let url = ''
        url = '/rm/trainer/deleteTrainerOther'
        _this.$request.post(
          url, _this.trainerOtherDTOList[otherIndex]
        ).then(() => {
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              _this.trainerOtherDTOList.splice(otherIndex, 1)
            }
          })
        })
      }
    },
    // 增加文本
    addBrief () {
      this.trainerBriefDTOList.push({ 'briefType': '1', 'briefContent': '', 'imgAddr': '' })
    },
    addCurriculum () {
      this.trainerCurriculumDTOList.push({ 'curriculumType': '1', 'curriculumContent': '', 'imgAddr': '' })
    },
    addOther () {
      this.trainerOtherDTOList.push({ 'otherType': '1', 'otherContent': '', 'imgAddr': '' })
    },
    // 页面返回
    backPage () {
      // this.$router.go(-1)
      let _this = this
      _this.$confirm(_this.$t('trainer.cancelinfo'), _this.$t('prompt.title'), {
        confirmButtonText: _this.$t('confirm'),
        cancelButtonText: _this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        _this.tabRemove()
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
    // 页面勾选城市树事件
    getcitySelectList (args) {
      if (args && args.length > 0) {
        let citySelect = args[0].id
        this.dataForm.city = citySelect
      }else{
        this.dataForm.city = ''
      }
    },
    // 移除文件
    uploadBeforeRemove () {
      this.fileList = []
      this.dataForm.fileUpload = undefined
      this.dataForm.fileName = ''
      this.dataForm.fileId = ''
    },
    uploadCurriculumRemove () {
      this.curriculumFileList = []
      this.dataForm.fileCurriculumUpload = undefined
      this.dataForm.fileCurriculumName = ''
      this.dataForm.fileCurriculumId = ''
    },
    uploadOtherRemove () {
      this.otherFileList = []
      this.dataForm.fileOtherUpload = undefined
      this.dataForm.fileOtherName = ''
      this.dataForm.fileOtherId = ''
    },
    // 获取文件上的后的文件信息
    submitUploadSuccess (response, file) {
      if (response && response !== '') {
          let url =  response.data
          let filename = file.name
          let fileUpload = {
              fileId: 1,
              url:url,
              filename: filename
          }
          this.dataForm.fileUpload = fileUpload
        let param = { 'briefType': '2', 'briefContent': '', 'imgAddr': url }
        this.trainerBriefDTOList.push(param)
        this.fileList = []
      }
    },
    submitUploadCurriculumSuccess (response, file) {
      if (response && response !== '') {
          let url =  response.data
          let filename = file.name
          let fileUpload = {
              fileCurriculumId: 1,
              url:url,
              fileCurriculumName: filename
          }
          this.dataForm.fileCurriculumUpload = fileUpload
        let param = { 'curriculumType': '2', 'curriculumContent': '', 'imgAddr': url }
        this.trainerCurriculumDTOList.push(param)
        this.curriculumFileList = []
      }
    },
    submitUploadOtherSuccess (response, file) {
      if (response && response !== '') {
              let url =  response.data
              let filename = file.name
              let fileUpload = {
                  fileOtherId: 1,
                  url:url,
                  fileOtherName: filename
              }
              this.dataForm.fileOtherUpload = fileUpload
        let param = { 'otherType': '2', 'otherContent': '', 'imgAddr': url }
        this.trainerOtherDTOList.push(param)
        this.otherFileList = []
      }
    },
    handleExceed () {
      this.$message.warning('上传文件数量超过限制')
    },
    // //文件上传的校验
    beforeAvatarUpload (file) {
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      let uploadFormat = ['jpg', 'png', 'JPG', 'PNG']
      let falg = uploadFormat.indexOf(testmsg)
      if (falg === -1) {
        this.$message.warning('只能上传jpg/png文件')
        return false
      }
      // 上传文件限制5M
      let isLt2M = file.size / 1024 / 1024 <= 5
      if (!isLt2M) {
        this.$message.warning('上传文件大小不能超过 5MB!')
        return false
      }
    },
    // 上移/下移
    briefMoveUpward (briefIndex) {
      this.trainerBriefDTOList[briefIndex] = this.trainerBriefDTOList.splice(briefIndex - 1, 1, this.trainerBriefDTOList[briefIndex])[0]
    },
    briefMoveDown (briefIndex) {
      this.trainerBriefDTOList[briefIndex] = this.trainerBriefDTOList.splice(briefIndex + 1, 1, this.trainerBriefDTOList[briefIndex])[0]
    },
    curriculumMoveUpward (curriculumIndex) {
      this.trainerCurriculumDTOList[curriculumIndex] = this.trainerCurriculumDTOList.splice(curriculumIndex - 1, 1, this.trainerCurriculumDTOList[curriculumIndex])[0]
    },
    curriculumMoveDown (curriculumIndex) {
      this.trainerCurriculumDTOList[curriculumIndex] = this.trainerCurriculumDTOList.splice(curriculumIndex + 1, 1, this.trainerCurriculumDTOList[curriculumIndex])[0]
    },
    otherMoveUpward (otherIndex) {
      this.trainerOtherDTOList[otherIndex] = this.trainerOtherDTOList.splice(otherIndex - 1, 1, this.trainerOtherDTOList[otherIndex])[0]
    },
    otherMoveDown (otherIndex) {
      this.trainerOtherDTOList[otherIndex] = this.trainerOtherDTOList.splice(otherIndex + 1, 1, this.trainerOtherDTOList[otherIndex])[0]
    },
    // 团队分类
    getSelectList (args) {
      if (args && args !== '' && args.length > 0) {
        let tramClass = ''
        tramClass = args[0].id
        this.trainerAnnualTargetDTOList[this.trainerTargetIndex].groupType = tramClass
        this.trainerAnnualTargetDTOList[this.trainerTargetIndex].groupTypeName = args[0].treamCnName
      }else{
        this.trainerAnnualTargetDTOList[this.trainerTargetIndex].groupType = ''
        this.trainerAnnualTargetDTOList[this.trainerTargetIndex].groupTypeName = ''
      }
    }
  }
}
</script>
<style scoped>
@import "../../css/pkg-styles.css";
.link-type,
.par{
  position: relative;
}
.item{
  margin: 4px;
}
.pad{
  position: absolute;
  left:132px;
}
.link-type:focus {
  color: #337ab7;
  cursor: pointer;
}
.link-type:hover {
  color: rgb(32, 160, 255);
}
</style>
<style>
.briefContent > .el-input__count {
  position: initial !important;
  float: right !important;
}
  .par .el-form-item__label{
    float: none;
  }
</style>
<style lang="scss">
.pkg-module {
  .pkg-content-form {
    .el-input__inner {
      height: 34px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.pkg-module {
  margin-bottom: 30px;
  .pkg-content-title {
    background-color: #ccc;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    font-weight: bold;
    margin: 0;
    position: relative;
    .show-or-hide {
      font-size: 14px;
      height: 30px;
      line-height: 30px;
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 20px;
    }
  }
  .pkg-content-form-module-no {
    background: #FFF;
    border: 1px solid #DCDFE6;
    padding: 15px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04 );
    .li-module {
      width: 20%;
      margin-right: 5%;
      float: left;
      .li-name {
        color: #606266;
        line-height: 26px;
        font-size: 14px;
        margin: 0;
        text-indent: 10px;
      }
      .li-value {
        height: 34px;
        line-height: 34px;
        background-color: #F5F7FA;
        border: 1px solid #E4E7ED;
        padding: 0 15px;
        border-radius: 0px;
        color: #C0C4CC;
        margin: 0;
      }
    }
    .li-title {
      width: 100%;
      float: left;
      margin: 20px 0 0 0;
      color: #606266;
      text-indent: 10px;
    }
  }
  .pkg-content-form {
    padding: 20px;
    .contract-history-module {
      width: 20% !important;
      float: left;
      margin-right: 5%;
    }
  }
  .pkg-content-margin {
    margin-top: 10px;
  }
  .btn-position-right {
    text-align: right;
  }
  .el-tabs__item {
    cursor: pointer !important;
  }
  .isActive, .contract-active {
    color: #67c23a !important;
  }
  .pkg-content-stitle {
    margin: 0 0 12px 0;
  }
}
</style>
